import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { ChargeStatus } from './charge.status.enum';

const ChargeStatusCountSchema = z.record(
    z.union([z.string(), EnumSchema(ChargeStatus)]), // Key can be a string or a ChargeStatus
    z.number(), // Value is a number
);

export class ChargeStatusCountDto extends FromSchema(ChargeStatusCountSchema) {}
